(function () {
  // Il foglio "aggiungi al carrello" e' position: fixed e deve ancorarsi allo
  // schermo. Su iOS invece si ancorava al carosello: usciva dentro la fila di
  // prodotti, tagliato di quanto il carosello era stato scorso, e lo sfondo
  // scuro copriva solo il carosello invece di tutta la pagina.
  //
  // Un elemento position: fixed smette di riferirsi allo schermo se un suo
  // antenato ha certe proprieta' (contenitori scorrevoli, trasformazioni,
  // filtri, effetti applicati dal browser). Quali siano esattamente cambia da
  // browser a browser e Safari su iOS ne ha di suoi, non riproducibili altrove.
  // Invece di inseguirle una per una, mentre il foglio e' aperto lo spostiamo
  // in fondo al <body>: li' non ha piu' antenati dentro la card, quindi nessuna
  // di quelle proprieta' puo' raggiungerlo. Alla chiusura torna al suo posto.
  //
  // Lo spostamento avviene solo sotto i 990px, dove il foglio e' un cassetto
  // dal basso. Su desktop resta un menu attaccato alla card e li' deve stare.

  var SHEET_QUERY = '(max-width: 989px)';

  function sheetMode() {
    return window.matchMedia(SHEET_QUERY).matches;
  }

  function readVariants(wrapper) {
    try {
      return JSON.parse(wrapper.dataset.quickAddVariants || '[]');
    } catch (e) {
      return [];
    }
  }

  // Dopo lo spostamento il foglio non e' piu' figlio del wrapper: queste tre
  // funzioni sostituiscono querySelector/closest, che altrimenti non lo
  // ritroverebbero.
  function popoverOf(wrapper) {
    return wrapper._qaPopover || wrapper.querySelector('[data-quick-add-popover]');
  }

  function wrapperOf(el) {
    if (!el || !el.closest) return null;
    var dentro = el.closest('[data-quick-add-wrapper]');
    if (dentro) return dentro;
    var spostato = el.closest('[data-quick-add-popover], [data-quick-add-backdrop]');
    return spostato && spostato._qaWrapper ? spostato._qaWrapper : null;
  }

  function moveToBody(wrapper) {
    if (wrapper._qaPopover) return;
    var popover = wrapper.querySelector('[data-quick-add-popover]');
    if (!popover) return;
    var backdrop = wrapper.querySelector('[data-quick-add-backdrop]');

    // Un commento vuoto segna il punto esatto da cui il foglio e' stato tolto,
    // cosi' alla chiusura torna dov'era e non in fondo al wrapper.
    var segnaposto = document.createComment('foglio aggiunta rapida');
    popover.parentNode.insertBefore(segnaposto, popover);
    wrapper._qaAnchor = segnaposto;

    if (backdrop) {
      backdrop._qaWrapper = wrapper;
      wrapper._qaBackdrop = backdrop;
      document.body.appendChild(backdrop);
    }
    popover._qaWrapper = wrapper;
    wrapper._qaPopover = popover;
    document.body.appendChild(popover);
  }

  function moveBack(wrapper) {
    var popover = wrapper._qaPopover;
    if (!popover) return;
    var backdrop = wrapper._qaBackdrop;
    var segnaposto = wrapper._qaAnchor;

    if (segnaposto && segnaposto.parentNode) {
      if (backdrop) segnaposto.parentNode.insertBefore(backdrop, segnaposto);
      segnaposto.parentNode.insertBefore(popover, segnaposto);
      segnaposto.parentNode.removeChild(segnaposto);
    } else if (document.contains(wrapper)) {
      // Il punto di partenza e' sparito ma la card c'e' ancora: rimetto in coda.
      if (backdrop) wrapper.appendChild(backdrop);
      wrapper.appendChild(popover);
    } else {
      // La card e' stata sostituita (filtri, ordinamento, paginazione):
      // il foglio non ha piu' un posto dove tornare, si butta.
      if (backdrop && backdrop.parentNode) backdrop.parentNode.removeChild(backdrop);
      if (popover.parentNode) popover.parentNode.removeChild(popover);
    }

    popover._qaWrapper = null;
    if (backdrop) backdrop._qaWrapper = null;
    wrapper._qaPopover = null;
    wrapper._qaBackdrop = null;
    wrapper._qaAnchor = null;
  }

  // Se la griglia viene ridisegnata mentre un foglio e' aperto, quel foglio
  // resterebbe nel <body> senza piu' una card a cui appartenere.
  function removeOrphans() {
    document
      .querySelectorAll('body > [data-quick-add-popover], body > [data-quick-add-backdrop]')
      .forEach(function (el) {
        var wrapper = el._qaWrapper;
        if (wrapper && document.contains(wrapper)) return;
        if (el.parentNode) el.parentNode.removeChild(el);
      });
  }

  function pillGroups(popover) {
    return Array.from(popover.querySelectorAll('[data-pill-group]'));
  }

  function groupSelectedValue(group) {
    var active = group.querySelector('.card-quick-add__pill.active');
    return active ? active.dataset.value : null;
  }

  function clearGroup(group) {
    group.querySelectorAll('.card-quick-add__pill').forEach(function (pill) {
      pill.classList.remove('active');
      pill.setAttribute('aria-pressed', 'false');
    });
  }

  function matchesSelection(variant, selection) {
    return selection.every(function (value, index) {
      return value === null || variant.options[index] === value;
    });
  }

  function hasAvailableMatch(variants, selection) {
    return variants.some(function (variant) {
      return variant.available && matchesSelection(variant, selection);
    });
  }

  function closeAllPopovers(except) {
    document.querySelectorAll('[data-quick-add-wrapper]').forEach(function (wrapper) {
      if (wrapper === except) return;
      var popover = popoverOf(wrapper);
      if (!popover || popover.hidden) return;
      popover.hidden = true;
      moveBack(wrapper);
      var toggle = wrapper.querySelector('[data-quick-add-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
    removeOrphans();
  }

  // Una scelta non deve mai portare in un vicolo cieco: si tiene il valore
  // appena toccato e si azzerano solo le altre scelte incompatibili.
  function dropConflictingChoices(wrapper, keepIndex) {
    var variants = readVariants(wrapper);
    var groups = pillGroups(popoverOf(wrapper));
    var selection = groups.map(groupSelectedValue);
    var kept = groups.map(function () {
      return null;
    });
    kept[keepIndex] = selection[keepIndex];

    groups.forEach(function (group, index) {
      if (index === keepIndex || selection[index] === null) return;
      var candidate = kept.slice();
      candidate[index] = selection[index];
      if (hasAvailableMatch(variants, candidate)) {
        kept[index] = selection[index];
      } else {
        clearGroup(group);
      }
    });
  }

  function updatePillAvailability(wrapper) {
    var variants = readVariants(wrapper);
    var popover = popoverOf(wrapper);
    var groups = pillGroups(popover);
    var selection = groups.map(groupSelectedValue);

    groups.forEach(function (group, index) {
      group.querySelectorAll('.card-quick-add__pill').forEach(function (pill) {
        var value = pill.dataset.value;
        var everSellable = variants.some(function (variant) {
          return variant.available && variant.options[index] === value;
        });
        var candidate = selection.slice();
        candidate[index] = value;
        var compatible = hasAvailableMatch(variants, candidate);

        // Disattivato solo se quel valore non è acquistabile in nessuna
        // combinazione; se è solo incompatibile con la scelta attuale resta
        // cliccabile e il click ricompone la selezione.
        pill.disabled = !everSellable;
        pill.classList.toggle('card-quick-add__pill--unavailable', !everSellable || !compatible);
      });
    });
  }

  function updateConfirmState(wrapper) {
    var variants = readVariants(wrapper);
    var popover = popoverOf(wrapper);
    var selection = pillGroups(popover).map(groupSelectedValue);
    var complete = selection.every(function (value) {
      return value !== null;
    });

    // Cercati dentro il foglio, non dentro il wrapper: quando il foglio e'
    // spostato nel <body> il wrapper non li contiene piu'.
    var input = popover.querySelector('[data-quick-add-input]');
    var confirmButton = popover.querySelector('[data-quick-add-confirm]');
    var errorEl = popover.querySelector('[data-quick-add-error]');
    if (!input || !confirmButton) return;

    var match = complete
      ? variants.find(function (variant) {
          return matchesSelection(variant, selection);
        })
      : null;

    if (match && match.available) {
      input.value = match.id;
      confirmButton.disabled = false;
      if (errorEl) errorEl.hidden = true;
    } else {
      input.value = '';
      confirmButton.disabled = true;
      if (errorEl) errorEl.hidden = !complete;
    }
  }

  function openPopover(wrapper) {
    var popover = popoverOf(wrapper);
    if (!popover) return;
    var toggle = wrapper.querySelector('[data-quick-add-toggle]');
    closeAllPopovers(wrapper);
    if (sheetMode()) moveToBody(wrapper);
    popover.hidden = false;
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    updatePillAvailability(wrapper);
    updateConfirmState(wrapper);
    var firstPill = popover.querySelector('.card-quick-add__pill:not([disabled])');
    if (firstPill) firstPill.focus();
  }

  function closePopover(wrapper, returnFocus) {
    var popover = popoverOf(wrapper);
    var toggle = wrapper.querySelector('[data-quick-add-toggle]');
    if (popover) popover.hidden = true;
    moveBack(wrapper);
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      if (returnFocus) toggle.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var submitButton = event.target.closest(
      '.card-quick-add__button:not([data-quick-add-toggle]), .card-quick-add__confirm'
    );
    if (submitButton) {
      event.preventDefault();
      if (submitButton.disabled) return;
      var form = submitButton.closest('form');
      if (form && typeof form.requestSubmit === 'function') form.requestSubmit(submitButton);
      else if (form) form.submit();
      return;
    }

    if (event.target.closest('[data-quick-add-backdrop]')) {
      event.preventDefault();
      closeAllPopovers();
      return;
    }

    var toggle = event.target.closest('[data-quick-add-toggle]');
    if (toggle) {
      event.preventDefault();
      var toggleWrapper = wrapperOf(toggle);
      if (!toggleWrapper) return;
      var togglePopover = popoverOf(toggleWrapper);
      if (togglePopover && !togglePopover.hidden) closePopover(toggleWrapper, true);
      else openPopover(toggleWrapper);
      return;
    }

    var pill = event.target.closest('.card-quick-add__pill');
    if (pill) {
      event.preventDefault();
      if (pill.disabled) return;

      var wrapper = wrapperOf(pill);
      if (!wrapper) return;
      var groups = pillGroups(popoverOf(wrapper));
      var group = pill.closest('[data-pill-group]');
      var index = groups.indexOf(group);
      var wasActive = pill.classList.contains('active');

      clearGroup(group);
      if (!wasActive) {
        pill.classList.add('active');
        pill.setAttribute('aria-pressed', 'true');
        dropConflictingChoices(wrapper, index);
      }

      updatePillAvailability(wrapper);
      updateConfirmState(wrapper);
      return;
    }

    // wrapperOf e non closest: un tocco dentro il foglio spostato nel <body>
    // deve contare come "dentro", altrimenti il foglio si chiuderebbe da solo.
    if (!wrapperOf(event.target)) {
      closeAllPopovers();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var wrapper = wrapperOf(event.target);
    var popover = wrapper ? popoverOf(wrapper) : null;
    if (popover && !popover.hidden) {
      closePopover(wrapper, true);
    } else {
      closeAllPopovers();
    }
  });

  // Ruotando il telefono si puo' passare fra cassetto dal basso e menu
  // attaccato alla card: si chiude tutto, cosi' il foglio non resta nel posto
  // sbagliato.
  window.addEventListener('resize', function () {
    closeAllPopovers();
  });

  // Filtri, ordinamento e paginazione riscrivono la griglia. Se succede mentre
  // un foglio e' aperto, la card che lo aveva aperto sparisce e il foglio
  // resterebbe nel <body> con lo schermo scurito finche' non si tocca qualcosa.
  function watchGridReplacements() {
    var grid = document.getElementById('ProductGridContainer');
    if (!grid || grid.dataset.quickAddWatch) return;
    grid.dataset.quickAddWatch = 'true';
    new MutationObserver(removeOrphans).observe(grid, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchGridReplacements);
  } else {
    watchGridReplacements();
  }
})();
